import {
  ADD_DOCUMENT_TYPE_FAIL,
  ADD_DOCUMENT_TYPE_SUCCESS,
  ADD_DOCUMENT_TYPE_REQUEST,
  DELETE_DOCUMENT_TYPE_REQUEST,
  DELETE_DOCUMENT_TYPE_SUCCESS,
  GETDETAIL_DOCUMENT_TYPE_REQUEST,
  GETDETAIL_DOCUMENT_TYPE_FAIL,
  GETDETAIL_DOCUMENT_TYPE_SUCCESS,
  UPDATE_DOCUMENT_TYPE_FAIL,
  UPDATE_DOCUMENT_TYPE_SUCCESS,
  UPDATE_DOCUMENT_TYPE_REQUEST,
  DELETE_DOCUMENT_TYPE_FAIL,
  GETALL_DOCUMENT_TYPE_FAIL,
  GETALL_DOCUMENT_TYPE_SUCCESS,
  GETALL_DOCUMENT_TYPE_REQUEST,
  CLEAR_DOCUMENTS_RECORD,
} from "../constant//DocumentsTypeConstant";

const initialState = {
  loading: false,
  action: "Document Type",
  result: [],
  singledata: [],
  message: "",
  error: "",
  success: false,
};

const DocumentsTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_DOCUMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETALL_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };
    case GETALL_DOCUMENT_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: action.message,
      };
    case GETDETAIL_DOCUMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETDETAIL_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GETDETAIL_DOCUMENT_TYPE_FAIL:
      return {
        loading: false,
        error: action.error,
        message: action.message,
      };
    case ADD_DOCUMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case ADD_DOCUMENT_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        message: action.message,
      };

    case UPDATE_DOCUMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
      };
    case UPDATE_DOCUMENT_TYPE_FAIL:
      return {
        loading: false,
        success: false,
        error: action.payload,
        message: action.message,
      };

    case DELETE_DOCUMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_DOCUMENT_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: action.message,
      };
    case CLEAR_DOCUMENTS_RECORD:
      return {
        ...state,
        loading: false,
        result: [],
        singledata: [],
        message: action.message,
      };
    default:
      return state;
  }
};

export default DocumentsTypeReducer;
